import { forwardRef } from "react";
import { Badge, type BadgeProps } from "./Badge";
import type { ConversationStatus } from "@/modules/chatbot/types";

/**
 * ConversationStateBadge — OPEN / AI_HANDLING / HUMAN_HANDOFF / CLOSED / ARCHIVED / SPAM.
 */

const META: Record<
  ConversationStatus,
  { label: string; variant: BadgeProps["variant"]; dot: boolean }
> = {
  OPEN: { label: "Ochiq", variant: "info", dot: true },
  AI_HANDLING: { label: "AI javob bermoqda", variant: "aurora", dot: true },
  HUMAN_HANDOFF: { label: "Operator", variant: "warning", dot: true },
  CLOSED: { label: "Yopildi", variant: "muted", dot: false },
  ARCHIVED: { label: "Arxiv", variant: "muted", dot: false },
  SPAM: { label: "Spam", variant: "danger", dot: true },
};

export interface ConversationStateBadgeProps
  extends Omit<BadgeProps, "variant" | "children"> {
  status: ConversationStatus;
}

export const ConversationStateBadge = forwardRef<
  HTMLSpanElement,
  ConversationStateBadgeProps
>(({ status, ...props }, ref) => {
  const meta = META[status];
  return (
    <Badge ref={ref} variant={meta.variant} dot={meta.dot} {...props}>
      {meta.label}
    </Badge>
  );
});
ConversationStateBadge.displayName = "ConversationStateBadge";
